import React from 'react';
import styled from 'styled-components';
import { MapPin, Phone, Mail } from 'lucide-react';


const SimpleConferenceFooter = () => {
  return(
    <FooterContainer>
      <FooterContent>
        <ContactSection className="contact">
          <h3>For more information</h3>
          <div className="contact-info">
            <MapPin />
            <p>104 Old Engineering Building, Off Anne Jiaggi Road. University of Ghana, Legon, Accra. GA-521-1966</p>
          </div>
          <div className="contact-info">
            <Phone />
            <p>Tel: +233 24 333 2248</p>
          </div>
          <div className="contact-info">
            <Mail />
            <p>amrsghana@gmail.com</p>
          </div>
        </ContactSection>

        <QuickLinksSection>
          <ul>
            <li><a href="/iumrs-icam25">Home</a></li>
            <li><a href="/iumrs-icam25/registration">Conference Registration</a></li>
            <li><a href="/iumrs-icam25/abstract-submission">Abstract Submission</a></li>
            <li><a href="/iumrs-icam25/speakers/plenary">Plenary speakers</a></li>
            <li><a href="/iumrs-icam25/conference-venue">Venue Information</a></li>
            <li><a href="https://visitghana.com/">Visit Ghana</a></li>
          </ul>
        </QuickLinksSection>

        <Copyright>
          <p>© 2025 IUMRS-ICAM 2025. All rights reserved.</p>
        </Copyright>
      </FooterContent>
  </FooterContainer>
    )
}

const FooterContainer = styled.footer`
  background-color: #082D4A;
  color: #fff;
  padding: 1.5rem 0 1.5rem;
  font-family: 'Arial', sans-serif;
  margin-top: 8rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const ContactSection = styled.div`
  margin-bottom: 1.5rem;

  h3 {
    color: #CA9D3B;
    font-size: 1.25rem;
    margin-bottom: 1rem;
    font-weight: 600;
  }

  .contact-info {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.75rem;
    
    svg {
      margin-right: 0.75rem;
      min-width: 1.25rem;
      color: #CA9D3B;
    }
    
    p {
      margin: 0;
      line-height: 1.5;
    }
  }
`;

const QuickLinksSection = styled.div`
  margin: 1.5rem 0;
  padding: 1.5rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  ul {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      a {
        color: #fff;
        text-decoration: none;
        transition: color 0.2s ease;
        font-size: 0.95rem;
        
        &:hover {
          color: #CA9D3B;
        }
      }
    }
  }
  
  @media (max-width: 640px) {
    ul {
      flex-direction: column;
      gap: 0.75rem;
    }
  }
`;

const Copyright = styled.div`
  font-size: 0.875rem;
  color: rgba(255, 255, 255, 0.7);
`;
export default SimpleConferenceFooter;